import React, { Component } from "react";
import { Button, Form, Card, Input, Dimmer, Loader, Modal, Header, Image, Grid } from "semantic-ui-react";
import {
  Redirect
} from "react-router-dom";
import { I18n } from 'react-i18next';
import LanguageSwitch from '../components/LanguageSwitch'
import API from '../utils/API'
import {notify} from 'react-notify-toast';
import logo from '../images/logo.png'
import { translate } from 'react-i18next';
import apple from '../images/apple.png'
import android from '../images/android.png'
import googleLogo from '../images/google-logo.png'
import facebookLogo from '../images/facebook-logo.png'
import { GoogleLogin } from 'react-google-login-component';
import { FacebookLogin } from 'react-facebook-login-component';

const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

class LoginPage extends Component {
    state = {
        signupView: false,
        resetView: false,
        email: null,
        password: null,
        fetching: false,
        logged: false,
        user: null,
        localStorageAvailable: true,
        emailForResetPassword: '',
        resetPasswordLoading: false
    }

  componentDidMount() {
    try {
      const token = window.localStorage.gwps
      if (token) {
        this.setState({logged: true})
      }
    } catch(e) {
      this.setState({localStorageAvailable: false})
    }
  }

  toggleView () {
    this.setState({signupView: !this.state.signupView})
  }

  toggleResetView () {
    this.setState({resetView: !this.state.resetView})
  }

  async login() {
    if (!this.state.email || !this.state.password) {
      return notify.show('Oh no!', 'error')
    }
    this.setState({fetching: true})
    const response = await API.login(this.state.email, this.state.password)
    if (response.ok) {
      // notify.show('OK!', 'success')
      window.localStorage.gwps = response.data.token
      this.setState({fetching: false, logged: true, user: response.data.user})
    } else {
      notify.show('An error occured', 'error')
      this.setState({fetching: false})
    }
  }

  async responseGoogle (googleUser) {
    var id_token = googleUser.getAuthResponse().access_token;
    // var googleId = googleUser.getId();
    try {
      const response = await API.logUserFromService('google', id_token)
      if (response.ok) {
        // notify.show('OK!', 'success')
        window.localStorage.gwps = response.data.token
        this.setState({fetching: false, logged: true, user: response.data.user})
      } else {
        notify.show('An error occured', 'error')
        this.setState({fetching: false})
      }
    } catch (error) {
      console.error(error)
    }
  }

  async resetPassword() {
    this.setState({resetPasswordLoading: true})
    try {
      const response = await API.resetUserPassword(this.state.emailForResetPassword)
      if (response.ok) {
        notify.show(this.props.t('messages:resetOK'), 'success')
        this.setState({emailForResetPassword: '', resetPasswordLoading: false, resetView: false})
      } else {
        notify.show('An error occured', 'error')
        this.setState({fetching: false})
      }
    } catch (error) {
      console.error(error)
    }
  }

  async responseFacebook (response) {
    var id_token = response.accessToken;
    // var googleId = googleUser.getId();
    try {
      const response = await API.logUserFromService('facebook', id_token)
      if (response.ok) {
        // notify.show('OK!', 'success')
        window.localStorage.gwps = response.data.token
        this.setState({fetching: false, logged: true, user: response.data.user})
      } else {
        notify.show('An error occured', 'error')
        this.setState({fetching: false})
      }
    } catch (error) {
      console.error(error)
    }
  }

  render() {
    return (
      <I18n ns="translations">
      {
          (t, { i18n }) => (
        <div id="auth-container">
          <div id="language-switch-container">
            <LanguageSwitch />
          </div>
          <Card>
            <Card.Content>
              <Card.Header id="auth-title"><Image centered src={logo} size='small' /><span>Espace membre</span></Card.Header>
              <Card.Description>
                {this.state.fetching && 
                  <Dimmer active>
                    <Loader />
                  </Dimmer>
                }
                {!this.state.fetching &&
                  <div>
                    <Form>
                      <Form.Field>
                          <Input type="email" onChange={(e, data) => this.setState({email: data.value})} icon='user' iconPosition='left' placeholder={t('common:email')} />
                      </Form.Field>
                      <Form.Field>
                          <Input type="password" onChange={(e, data) => this.setState({password: data.value})} icon='lock' iconPosition='left' placeholder={t('common:password')} />
                      </Form.Field>
                    </Form>
                    <Button style={{marginTop: 10, marginBottom: 20}} disabled={!this.state.localStorageAvailable} onClick={this.login.bind(this)} fluid>{t('auth:signIn')}</Button>
                    <div id="google-button-container">
                      <Image id="google-logo" size="small" src={googleLogo} />
                      <GoogleLogin socialId="1060856667605-uh66dirp5n5vljkn6gv1kkj9lv0gug11.apps.googleusercontent.com"
                        className="google-login ui fluid button"
                        scope="profile email https://www.googleapis.com/auth/user.birthday.read"
                        prompt="select_account"
                        fetchBasicProfile={false}
                        responseHandler={this.responseGoogle.bind(this)}
                        buttonText={t('auth:signinGoogle')}/>
                    </div>
                    <div id="facebook-button-container">
                    <Image id="facebook-logo" size="small" src={facebookLogo} />
                    <FacebookLogin socialId="826637227668047"
                       language="en_US"
                       scope="public_profile,email,user_birthday"
                       responseHandler={this.responseFacebook.bind(this)}
                       xfbml={true}
                       fields="id,email,first_name,last_name"
                       version="v3.2"
                       className="facebook-login ui fluid button"
                       buttonText={t('auth:signinFacebook')}/>
                       </div>
                    {!this.state.localStorageAvailable && <p id="localstorage-error">{t('auth:localstorageError')}</p>}
                  </div>
                }
              </Card.Description>
            </Card.Content>
            <Card.Content extra id="auth-footer">
            <Modal open={this.state.resetView} onClose={this.toggleResetView.bind(this)} trigger={<a className="link" onClick={this.toggleResetView.bind(this)}>{t('auth:forgotPassword')}</a>}>
              <Modal.Content>
                <Modal.Description>
                  <Header>{t('auth:forgotPassword')}</Header>
                  <p className="text-center">{t('auth:forgotPasswordContent')}</p>
                  <Form>
                    <Form.Field>
                      <input type="email" id="password-reset" onChange={e => this.setState({emailForResetPassword: e.target.value})} icon='email' iconPosition='left' placeholder={t('common:email')} value={this.state.emailForResetPassword}/>
                    </Form.Field>
                  </Form>
                  <Button style={{display: 'block', margin: 'auto', marginTop: 10, alignSelf: 'center'}} disabled={!EMAIL_REGEXP.test(this.state.emailForResetPassword.toLowerCase())} onClick={this.resetPassword.bind(this)} loading={this.state.resetPasswordLoading}>{t('premium:subscribeModal.validate')}</Button>
                </Modal.Description>
              </Modal.Content>
            </Modal>
            <br/><br/>
            <Modal trigger={<a className="link" onClick={this.toggleView.bind(this)}>{t('auth:notRegistered')}</a>}>
              <Modal.Content>
                <Modal.Description>
                  <Header>{t('auth:modal.title')}</Header>
                  <p className="text-center">{t('auth:modal.content')}</p>
                  <Grid columns={2} divided stackable className="mt30">
                  <Grid.Row>
                    <Grid.Column>
                      <a href="https://itunes.apple.com/us/app/gowod/id1227834875" target="_blank" rel="noopener noreferrer">
                        <Image centered size="small" src={apple} />
                      </a>
                    </Grid.Column>
                    
                    <Grid.Column>
                      <a href="https://play.google.com/store/apps/details?id=eu.gowod" target="_blank" rel="noopener noreferrer">
                        <Image centered size="small" src={android} />
                      </a>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                </Modal.Description>
              </Modal.Content>
            </Modal>
            </Card.Content>

          </Card>
          {(this.state.logged || (this.localStorageAvailable && window.localStorage.gwps)) && <Redirect to={{ pathname: "/home", state: {user: this.state.user}}}/>}
        </div>
        )
      }
      </I18n>
    );
  }
}

export default translate('translations')(LoginPage);



// WEBPACK FOOTER //
// ./src/pages/AuthPage.js